export const STORE_IDEAL_RANGES = "STORE_IDEAL_RANGES";
export const STORE_TOPIC_DURATION = "STORE_TOPIC_DURATION";
export const TOPIC_SNIPPETS_LOADING = "TOPIC_SNIPPETS_LOADING";
